export default function CapnoLearningNewCourseCard() {
  return (
    <div className="capnocard" style={{display:"flex", position:"relative", bottom: 0, marginTop: "auto", justifyContent: "end"}}>
    <div className=" border border-black rounded-md  bg-white" style={{padding: "5px", width: "100%"}}>
      {/* <h6 className="font-bold text-center font-red">CERTIFICATION ADMISSIONS REQUIREMENTS</h6> */}
      <p className="text-gray-800 text-sm" style={{fontSize: "12px"  , marginBottom: "0px"}}>
       <span style={{color: "red"}} className="font-bold">For Specialty Certification programs, Click on the “prerequisite” icon to be sure you qualify for admission.</span>  <hr style={{margin: "5px auto"}} />  <span className="font-bold">CapnoTrainer rentals are available to registered students. This option will appear in your confirmation email.</span>
          
        </p> 
    </div>
    </div>
  );
}


// Click here to be sure you qualify for admission.

// At top of regitseration page 

// add for e-campus to manage

// If you wish to register for this  specialist version of the generic  Certified CapnoLearning® Breathing Practitioner program, do NOT do so until you have read its very specific admissions requirements. Click here to <a href=""> review the requirements </a>. If in doubt, register for the generic program. Admissions exceptions will not be made.

// Click here to <a href=""> review admission requirements </a>. If in doubt about registering in  a specilty version of the capno breath prpgram, register for the generic program. Admissions exceptions will not be made.

// Click here to review program requirements. If in doubt, be sure to contact us at education@bp.edu.